<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon">
      <i class="far fa-clock"></i>
      {{ "ScheduleSetting.ScheduleEffectiveTimeSettingHeader" | translate }}
    </span>
  </h1>
  <p-card>
    <p-accordion>
      <p-accordionTab
        [selected]="isSearchFormOpen"
        header="{{ 'Common.Button.Search' | translate }}"
      >
        <form [formGroup]="searchForm">
          <div class="fluid formgrid grid">
            <div class="field col-4 md-4">
              <label for="plant"
                ><span class="requiredStart">*</span
                >{{ "ScheduleSetting.Search.Plant" | translate }}</label
              >
              <div class="item">
                <laas-plant-dropdown
                  [isSingle]="true"
                  [permissionCode]="viewPermissionCode"
                  formControlName="plant"
                  (onOptionDataChange)="searchRequest.plant = $event"
                ></laas-plant-dropdown>
                <div
                  *ngIf="
                    (submitted || searchForm.controls.plant.touched) &&
                    searchForm?.controls?.plant?.errors?.required
                  "
                >
                  <small class="p-invalid">{{
                    "Common.Button.Required" | translate
                  }}</small>
                </div>
              </div>
            </div>
            <div class="field col-4 md-4">
              <label for="scheduleName"
                ><span class="requiredStart">*</span
                >{{ "ScheduleSetting.Search.ScheduleName" | translate }}</label
              >
              <div class="item">
                <p-dropdown
                  inputId="scheduleName"
                  [filter]="true"
                  formControlName="scheduleName"
                  [options]="settingHeaderOptions"
                  [(ngModel)]="searchRequest.scheduleName"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                ></p-dropdown>
                <div
                  *ngIf="
                    (submitted || searchForm.controls.scheduleName.touched) &&
                    searchForm?.controls?.scheduleName?.errors?.required
                  "
                >
                  <small class="p-invalid">{{
                    "Common.Button.Required" | translate
                  }}</small>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="mt-2">
          <button
            pButton
            type="button"
            label="{{ 'Common.Button.Search' | translate }}"
            (click)="search(true)"
          ></button>
          <button
            pButton
            type="button"
            label="{{ 'Common.Button.Reset' | translate }}"
            class="p-button-secondary"
            (click)="resetSearch()"
          ></button>
          <laas-permission-button
            permissionCode="BtnUrgentNoSetting"
            type="button"
            label="{{ 'ScheduleSetting.UrgentNoSetting.UrgentNoSettingButton' | translate }}"
            [class]="'p-button-success'"
            (onClick)="openUrgentNoSetting()"
          ></laas-permission-button>
        </div>
      </p-accordionTab>
    </p-accordion>
  </p-card>

  <p-table
    [value]="dates"
    [loading]="isLoading"
    [columns]="columns"
    [scrollable]="true"
    [scrollHeight]="'40vw'"
    [resizableColumns]="true"
    columnResizeMode="expand"
    [autoLayout]="true"
    styleClass="p-datatable-gridlines p-datatable-striped mt-2 dTable"
  >
    <ng-template pTemplate="caption" class="inline-block my-1">
      <ng-container *ngIf="isQuerySuccessful">
        <div class="flex items-center gap-2">
          <button
            *ngIf="!isEditable"
            pButton
            type="button"
            label="{{ 'Common.Button.Edit' | translate }}"
            icon="pi pi-pencil"
            class="ml-2"
            (click)="enableEdit()"
          ></button>
          <button
            *ngIf="isEditable"
            pButton
            pRipple
            type="button"
            label="{{ 'Common.Button.ExitEdit' | translate }}"
            icon="pi pi-times"
            class="p-button-secondary ml-2"
            (click)="cancelEdit(true)"
          ></button>
          <button
            *ngIf="isEditable"
            pButton
            pRipple
            type="button"
            label="{{ 'Common.Button.Save' | translate }}"
            class="ml-2"
            (click)="save()"
          ></button>
          <span>{{ 'ScheduleSetting.Messege.RedIsIneffectiveTime' | translate }}</span>
        </div>
      </ng-container>

    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <ng-container *ngFor="let col of columns">
          <th [style.width.px]="col.width ? col.width : 40">
            {{ col.header | translate }}
          </th>
        </ng-container>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-date let-i="rowIndex">
      <tr>
        <td [style.width.px]="100" [style.text-align]="'center'">{{ date }}</td>
        <td [style.width.px]="120" [style.white-space]="'pre-line'" [style.text-align]="'center'"> {{ getTime(i) }}</td>
        <td [style.width.px]="40" [style.text-align]="'center'">
          <i
            class="pi pi-trash"
            (click)="
              isEditable
                ? deleteBtnClick(i)
                : $event.stopImmediatePropagation()
            "
          ></i>
        </td>
        <td
          [style.width.px]="40"
          [style.text-align]="'center'"
          *ngFor="let hour of hours; let j = index"
          [ngClass]="{ highlight: showCells[i][j] }"
          (mousedown)="isEditable && onMouseDown(i, j, $event)"
          (mouseenter)="isEditable && onMouseEnter(i, j)"
          (mouseup)="
            isEditable && onMouseUp(i, j, $event); $event.stopPropagation()
          "
        ></td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog
    [(visible)]="isDialogOpen"
    header="{{
      'ScheduleSetting.ScheduleEffectiveTimeSettingTimeHeader' | translate
    }}"
    appendTo="body"
    [modal]="true"
    [closable]="false"
    [style]="{ width: '30vw' }"
  >
    <div>
      <p>{{ "ScheduleSetting.Messege.MinuteRemind" | translate }}</p>
      <form>
        <div class="field">
          <label for="startMinute">{{
            "ScheduleSetting.TimeDialog.StartMinute" | translate
          }}</label>
          <input
            id="startMinute"
            type="number"
            pInputText
            [(ngModel)]="dialogData.startMinute"
            name="startMinute"
            min="0"
            max="59"
            class="ml-2"
          />
        </div>
        <div class="field">
          <label for="endMinute">{{
            "ScheduleSetting.TimeDialog.EndMinute" | translate
          }}</label>
          <input
            id="endMinute"
            type="number"
            pInputText
            [(ngModel)]="dialogData.endMinute"
            name="endMinute"
            min="0"
            max="59"
            class="ml-2"
          />
        </div>
      </form>
    </div>
    <p *ngIf="!validateMinutes()" style="color: red">
      {{ "ScheduleSetting.Messege.MinuteRemind" | translate }}
    </p>
    <p-footer>
      <button
        pButton
        label="{{ 'Common.Button.Confirm' | translate }}"
        icon="pi pi-check"
        (click)="closeDialog(true)"
        [disabled]="!validateMinutes()"
      ></button>
      <button
        pButton
        label="{{ 'Common.Button.Cancel' | translate }}"
        icon="pi pi-times"
        class="p-button-text"
        (click)="closeDialog(false)"
      ></button>
    </p-footer>
  </p-dialog>

  <p-dialog
    [(visible)]="showUrgentNoSetting"
    [style]="{ minWidth: '60%', minHeight: '400px' }"
    header="{{
      'ScheduleSetting.UrgentNoSetting.Header' | translate
    }}"
    appendTo="body"
    [modal]="true"
    [draggable]="false"
    (onHide)="onUrgentNoSettingHide()"
  >
    <div *ngIf="isUrgentSettingLoading" class="loadingMask">
      <p-progressSpinner></p-progressSpinner>
    </div>
    <div class="p-fluid formgrid grid align-items-center">
      <div class="field col-12 md:col-6 mb-0">
        <label for="urgentSettingScheduleName">
          {{ "ScheduleSetting.Search.ScheduleName" | translate }}
        </label>
        <p-dropdown
          inputId="urgentSettingScheduleName"
          [filter]="true"
          [options]="settingHeaderOptions"
          [(ngModel)]="urgentSettingScheduleName"
          (onChange)="onUrgentSettingScheduleChange($event)"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
        ></p-dropdown>
      </div>
    </div>
    <div class="mt-3"></div>
    <laas-data-table
      *ngIf="showUrgentNoSetting"
      [dataKey]="'urgentNo'"
      [tableKey]="urgentNoPreferenceKey"
      [value]="urgentNoDatas"
      [defaultColumns]="urgentNoColumns"
      [scrollable]="true"
      [scrollHeight]="'300px'"
    >
      <ng-template pTemplate="caption">
        <div class="flex align-items-center gap-2">
          @if(isAddingUrgentNo) {
            <input
              pInputText
              type="text"
              [(ngModel)]="newUrgentNo"
              placeholder="{{ 'ScheduleSetting.UrgentNoSetting.UrgentNoInputPlaceholder' | translate }}"
            />
            <button
              pButton
              type="button"
              label="{{ 'Common.Button.Cancel' | translate }}"
              class="p-button-secondary p-button-raised"
              (click)="onUrgentNoSettingHide()"
            ></button>
            <button
              pButton
              type="button"
              label="{{ 'Common.Button.Confirm' | translate }}"
              icon="fas fa-save"
              class="p-button-success p-button-raised"
              (click)="confirmAddUrgentNo()"
            ></button>
          } @else {
            <button
              pButton
              type="button"
              label="{{ 'Common.Button.Add' | translate }}"
              icon="fas fa-plus"
              class="p-button-success p-button-raised"
              (click)="addUrgentNo()"
            ></button>
          }
        </div>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        @for (col of columns; track col.field) {
          <td>
            @switch(col.field) {
              @case('action') {
                <i class="pi pi-trash"
                  (click)="$event.stopPropagation(); deleteUrgentNo(rowData)"
                ></i>
              }
              @default {
                <div class="p-fluid overflow-text">
                  {{ rowData[col.field] | replaceNullWith : "-" }}
                </div>
              }
            }
          </td>
        }
      </ng-template>
    </laas-data-table>

  </p-dialog>
</div>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
